import type { IBrowserClient } from '../browser-client.interface.js';

export interface ReflessSnapshotGateOptions {
  reflessSnapshots?: boolean;
}

export function resolveReflessSnapshotGate(options?: ReflessSnapshotGateOptions): boolean {
  return options?.reflessSnapshots === true;
}

export function applyReflessSnapshotGate(
  client: Pick<IBrowserClient, 'setReflessSnapshots'>,
  options?: ReflessSnapshotGateOptions
): boolean {
  const enabled = resolveReflessSnapshotGate(options);
  client.setReflessSnapshots?.(enabled);
  return enabled;
}
